import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import { useLocation } from 'react-router-dom';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import Content from 'ui/components/common/Tour/Content';

const useGetViewCreatedDeals = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const { pathname } = useLocation();
  const isInDealsPage = pathname.includes('deals');

  const isCollapsed = state?.collapse;

  const viewCreatedDealsSteps: StepType[] = [
    ...(!isInDealsPage
      ? ([
          {
            content: 'Go to the Sales menu tab',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
            position: 'right',
            action: (node) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(1), 1000);
                },
                false,
              );
            },
            disableActions: true,
            styles: {
              arrow: (base) => ({
                ...base,
                visibility: 'hidden',
              }),
            },
          },
        ] as StepType[])
      : []),
    ...(!isInDealsPage
      ? ([
          {
            content: 'Then select Deals to view the Deals page',
            position: 'right',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SUBMENU}"]`,
            action: (node) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(2), 1000);
                },
                false,
              );
            },
            disableActions: false,
            styles: {
              arrow: (base) => ({
                ...base,
              }),
            },
          },
        ] as StepType[])
      : []),
    {
      content: (props) => (
        <Content
          content="On this page you can view all your created Deals."
          {...props}
          endTour
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEALS_BOARD}"]`,
      stepInteraction: false,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
    },
  ];

  const showViewCreatedDealsSteps = () => {
    if (isCollapsed && !isInDealsPage) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(viewCreatedDealsSteps);
      setIsOpen(true);
    }, 300);
  };

  return showViewCreatedDealsSteps;
};

export default useGetViewCreatedDeals;
